module.exports = __webpack_public_path__ + "media/src/ui/images/icon_camera-f1aa99155fb93f0dcb72eef08da2deec.svg";